// src/shared/components/query-error-state.tsx
// PROD-1654 / PROD-1657 — the ERROR-vs-EMPTY primitive. A failed query must NEVER render as
// the surface's empty state ("No providers available…", "No responses submitted…"): a user
// cannot distinguish an outage from a true zero, and the QA reliability standard forbids a
// failed request rendering as success/empty. Render THIS (red, role=alert, with a retry
// affordance) on `isError`; keep the existing quiet empty-state copy for a true empty 200.
// Consumers so far: the provider-slot search surfaces (create-appointment panel grid,
// full-screen provider search, recurrence reselect, block-availability picker). The encounter
// QR reload uses the shell's red save-indicator channel for the same rule (PROD-1654).
// DS-first: composes the DS HelperText atom at tone="error" — no hand-rolled error chrome.
import { HelperText } from '@scripsteam/scrips-signal-ds';

export function QueryErrorState({
  message,
  onRetry,
  className,
}: {
  /** Plain-words description of WHAT failed to load, e.g. "Couldn't load providers." */
  message: string;
  /** Refetch affordance — pass the query's `refetch`. Omitted → message only. */
  onRetry?: () => void;
  className?: string;
}) {
  return (
    // No role here — the DS HelperText atom already announces itself as role="alert" at tone="error".
    <div className={`flex flex-col items-center gap-2 py-6 ${className ?? ''}`}>
      <HelperText tone="error" className="m-0">{message}</HelperText>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="h-8 px-4 rounded-lg border border-border-default bg-surface-card text-sm font-medium text-brand-primary hover:border-brand-primary hover:bg-blue-100 transition-colors"
        >
          Retry
        </button>
      )}
    </div>
  );
}
